export class MediaUtils {
  static of(wixMedia: any) {
    return new MediaUtils(wixMedia)
  }

  constructor(wixMedia: any) {
    this.#wixMedia = wixMedia
  }

  convertToUrl(value: any) {
    const mediaItem = this.#wixMedia.parseMediaItemUri(value)

    if (mediaItem.error) {
      throw new Error('MediaUtils: Failed to convert wix media uri to URL', { cause: mediaItem.error })
    }

    switch (mediaItem.type) {
      case this.#wixMedia.types.IMAGE:
        return this.#wixMedia.getScaleToFillImageURL(
          mediaItem.mediaId,
          mediaItem.width,
          mediaItem.height,
          mediaItem.width,
          mediaItem.height,
          { name: mediaItem.title },
        )

      case this.#wixMedia.types.VIDEO:
        return `https://video.wixstatic.com/video/${mediaItem.mediaId}/file`
      case this.#wixMedia.types.AUDIO:
        return `https://static.wixstatic.com/mp3/${mediaItem.mediaId}`
      default:
        throw new Error('MediaUtils: Unsupported media type')
    }
  }

  #wixMedia
}